import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../../environments/environment';
import {
  WorkflowConditionEvaluationRequest,
  WorkflowConditionEvaluationResponse,
  WorkflowExecutionContinueRequest,
  WorkflowExecutionContinueResponse
} from '../models/workflow-execution.model';

@Injectable({ providedIn: 'root' })
export class WorkflowExecutionApiService {
  private readonly apiUrl = `${environment.apiUrl}api/workflow-executions`;

  constructor(private http: HttpClient) {}

  continueByExecutionRun(
    executionRunId: number,
    request: WorkflowExecutionContinueRequest = {}
  ): Observable<WorkflowExecutionContinueResponse> {
    return this.http.post<WorkflowExecutionContinueResponse>(
      `${this.apiUrl}/${executionRunId}/continue`, request
    );
  }

  continueByEnrollment(
    enrollmentId: number,
    request: WorkflowExecutionContinueRequest = {}
  ): Observable<WorkflowExecutionContinueResponse> {
    return this.http.post<WorkflowExecutionContinueResponse>(
      `${this.apiUrl}/enrollments/${enrollmentId}/continue`, request
    );
  }

  evaluateCondition(
    enrollmentId: number,
    nodeId: number,
    request: WorkflowConditionEvaluationRequest = {}
  ): Observable<WorkflowConditionEvaluationResponse> {
    return this.http.post<WorkflowConditionEvaluationResponse>(
      `${this.apiUrl}/enrollments/${enrollmentId}/evaluate-condition/${nodeId}`, request
    );
  }
}
